import React, { useState } from "react";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { useData } from "@/context/DataContext";
import { GastoForm } from "./GastoForm";
import { eur } from "@/lib/gastos";

const btn = "min-h-[52px] rounded-xl font-semibold";

// Revisión de documento: decisión obligatoria sobre el gasto; el gasto solo se crea al confirmar el documento.
export const SugerenciaGasto = ({ docId, analisis, asociado, persona, decision, setDecision }) => {
  const { leerGasto } = useData();
  const [estado, setEstado] = useState(null);
  const [datos, setDatos] = useState(null);
  const si = async () => {
    setEstado("leyendo");
    let d = null;
    try { d = await leerGasto(docId); } catch { toast("No se pudieron leer todos los datos: complétalos tú."); }
    const imp = analisis?.importe?.valor;
    if (!d && imp != null) d = { importe_total: { valor: imp, confianza: analisis.importe.confianza ?? 1 } };
    setDatos(d);
    setEstado("form");
  };
  return (
    <div className="mt-4 bg-[#FFFBEB] border border-[#FDE68A] rounded-2xl p-4" data-testid="sugerencia-gasto">
      <p className="font-semibold text-base text-[#1C2421] flex gap-2"><Icons.Receipt size={20} className="text-[#B45309] shrink-0" /> Este documento tiene un importe. ¿Quieres registrarlo también en Gastos?</p>
      {decision.modo === "si" ? (
        <div className="mt-3 bg-white border border-[#E5DFD5] rounded-xl p-3" data-testid="sugerencia-gasto-preparado">
          <p className="text-base text-[#1C2421]">Se registrará en Gastos al confirmar: <b>{eur(decision.datos.importe)}</b>{decision.datos.proveedor ? ` · ${decision.datos.proveedor}` : ""}</p>
          <div className="grid grid-cols-2 gap-2 mt-3">
            <button data-testid="sugerencia-gasto-cambiar" onClick={() => setEstado("form")} className={`${btn} bg-white border border-[#E5DFD5]`}>Cambiar datos</button>
            <button data-testid="sugerencia-gasto-no" onClick={() => setDecision({ modo: "no" })} className={`${btn} bg-white border border-[#E5DFD5]`}>No es un gasto</button>
          </div>
        </div>
      ) : decision.modo === "no" ? (
        <div className="mt-3 flex items-center justify-between gap-2" data-testid="sugerencia-gasto-descartado">
          <p className="text-base text-[#4A5550]">No se registrará ningún gasto.</p>
          <button data-testid="sugerencia-gasto-reconsiderar" onClick={si} className="text-[#3A6B56] font-semibold underline min-h-[44px]">Sí es un gasto</button>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-2 mt-3">
          <button data-testid="sugerencia-gasto-si" disabled={estado === "leyendo"} onClick={si} className={`${btn} bg-[#3A6B56] text-white disabled:opacity-60`}>
            {estado === "leyendo" ? "Leyendo…" : "Registrar también en Gastos"}
          </button>
          <button data-testid="sugerencia-gasto-no" onClick={() => setDecision({ modo: "no" })} className={`${btn} bg-white border border-[#E5DFD5]`}>No es un gasto</button>
        </div>
      )}
      {estado === "form" && (
        <GastoForm docId={docId} detectado={decision.modo === "si" ? null : datos} gasto={decision.modo === "si" ? { ...decision.datos, documento_id: docId } : null}
          asociadoInicial={asociado || ""} personaInicial={persona || ""} origen="general" onClose={() => setEstado(null)}
          onDiferido={(p) => { setDecision({ modo: "si", datos: p, ini: { asociado: asociado || "", persona: persona || "" } }); setEstado(null); }} />
      )}
    </div>
  );
};
